import React from 'react';
import { SwedishCompanyForm as OldSwedishCompanyForm } from './swedish-company-form';
import { useIsFeatureEnabled } from 'tradera/hooks/use-is-feature-enabled';
import { SwedishCompanyForm } from './swedish-company-form-v2/swedish-company-form';

export const SwedishCompanyFormToggler = ({ antiForgeryToken }) => {
    if (
        !useIsFeatureEnabled(
            'money-transfer-license-company-sweden-registration'
        )
    )
        return <OldSwedishCompanyForm antiForgeryToken={antiForgeryToken} />;
    return <SwedishCompanyForm antiForgeryToken={antiForgeryToken} />;
};
